var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.addClass,attrs:{"href":_vm.href},domProps:{"textContent":_vm._s(_vm.text)},on:{"click":function($event){return _vm.checkMinimumOrder($event)}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ee0fa4a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Resources/assets/js/UI/components/proceed-to-checkout.vue
// module id = X1Np
// module chunks = 0